import { Commands } from '../../../../../../types/enums/Common';
import { Copy, Edit } from '@sweep-io/sweep-design/dist/icons';
import { DataTableSortableColumn } from '../../../../../common/table/TableTypes';
import { SortCompareTypes } from '../../../../../common/table/TableTypes';
import { SortOrder } from '../../../../../common/types';
import { RowWithActions } from './PanelCampaignsTab';
import { humanizeDate, humanizeDateVariants } from '../../../../../helpers/humanizeDate';

export const actionsMenuItems = [
  {
    label: Commands.Edit,
    value: Commands.Edit,
    actionIcon: <Edit />,
  },
  {
    label: Commands.Duplicate,
    value: Commands.Duplicate,
    actionIcon: <Copy />,
  },
];

export const campaignColumns: DataTableSortableColumn<RowWithActions>[] = [
  {
    field: 'name',
    headerName: 'Name',
    showSortIcon: true,
    sortCompare: {
      type: SortCompareTypes.Custom,
      compareFunction: (a: RowWithActions, b: RowWithActions, order: SortOrder) => {
        const aName = a._name;
        const bName = b._name;
        return order === SortOrder.ASC ? aName.localeCompare(bName) : bName.localeCompare(aName);
      },
    },
  },
  {
    field: 'type',
    headerName: 'Type',
    width: '150px',
    showSortIcon: true,
    sortCompare: {
      type: SortCompareTypes.String,
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: '150px',
    showSortIcon: true,
    sortCompare: {
      type: SortCompareTypes.String,
    },
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    width: '150px',
    showSortIcon: true,
    sortCompare: {
      type: SortCompareTypes.Custom,
      compareFunction: (a: RowWithActions, b: RowWithActions, order: SortOrder) => {
        const aDate = new Date(a.startDate).getTime();
        const bDate = new Date(b.startDate).getTime();
        return order === SortOrder.ASC ? aDate - bDate : bDate - aDate;
      },
    },
  },
  {
    field: 'endDate',
    headerName: 'End Date',
    width: '150px',
    showSortIcon: true,
    sortCompare: {
      type: SortCompareTypes.Custom,
      compareFunction: (a: RowWithActions, b: RowWithActions, order: SortOrder) => {
        const aDate = new Date(a.endDate).getTime();
        const bDate = new Date(b.endDate).getTime();
        return order === SortOrder.ASC ? aDate - bDate : bDate - aDate;
      },
    },
  },
  {
    field: 'expectedRevenue',
    headerName: 'Expected Revenue',
    width: '150px',
    showSortIcon: true,
    sortCompare: {
      type: SortCompareTypes.Custom,
      compareFunction: (a: RowWithActions, b: RowWithActions, order: SortOrder) => {
        const aRevenue = parseFloat(a.expectedRevenue) || 0;
        const bRevenue = parseFloat(b.expectedRevenue) || 0;
        return order === SortOrder.ASC ? aRevenue - bRevenue : bRevenue - aRevenue;
      },
    },
  },
  {
    field: '_lastModifiedDate',
    headerName: 'Last Modified Date',
    width: '200px',
    showSortIcon: true,
    sortCompare: {
      type: SortCompareTypes.Custom,
      compareFunction: (a: RowWithActions, b: RowWithActions, order: SortOrder) => {
        const aDate = new Date(a._lastModifiedDate).getTime();
        const bDate = new Date(b._lastModifiedDate).getTime();
        return order === SortOrder.ASC ? aDate - bDate : bDate - aDate;
      },
    },
    renderer: (value) => {
      return humanizeDate({
        dateOrTimestamp: value,
        variant: humanizeDateVariants.SHORT_WITH_TIME,
      });
    },
  },
];
